import React from "react";

/** Botón principal del formulario. Dice qué va a pasar, y luego qué está pasando. */
export default function SubmitButton({ children, loading, loadingLabel = "Un momento..." }) {
  return (
    <button className="auth-btn" type="submit" disabled={loading}>
      {loading ? (
        <>
          <span className="auth-btn-spinner" aria-hidden="true" />
          {loadingLabel}
        </>
      ) : (
        children
      )}
    </button>
  );
}
